module.exports = "/assets/data/b4474b47931ba56cf2c7cfba9187858a-BT20.data.json";